import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import * as cls from "./modalChangePassword.module.scss";
import { useSelector } from "react-redux";
import ShieldIcon from "../../resources/icons/ShielIcon";
import { AuthorizationService } from "../authorizationService";
import { Button } from "../../../personal-studio-components/form";

function ModalChangePassword({ isSwowModal, setIsShowModal }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const { access_token } = useSelector((state) => state.token);
  const [error, setError] = useState("");
  const [stage, setStage] = useState(1);
  const onKeyUp = (event) => {
    if (event.code === "NumpadEnter" || event.code === "Enter") {
      onPasswordChange();
    }
  };

  const onPasswordChange = async () => {
    if (newPassword.length < 8) {
      setError("Ваш пароль должен содержать не менее 8 символов");
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("Пароли не совпадают");
      return;
    }
    setError("");
    const request = {
      method: "post",
      path: "/password/change",
      data: {
        access_token,
        new_password: newPassword,
      },
    };
    try {
      await AuthorizationService.send(request, (response) => {});
      setStage(2);
    } catch (error) {
      const err = error.response.data;
      const errorEvent = new ErrorEvent("error", {
        error: err,
      });
      window.dispatchEvent(errorEvent);
    }
  };

  const handleClose = () => {
    setIsShowModal(false);
  };
  if (stage === 1)
    return (
      <Dialog
        fullScreen={fullScreen}
        open={isSwowModal}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        classes={{ paper: cls.dialog_paper }}
        onKeyUp={onKeyUp}
      >
        <div className={cls.title}>Изменение пароля</div>
        <DialogContent>
          Ваш пароль должен содержать не менее 8 символов.
        </DialogContent>

        <DialogContent>
          <div className={cls.login}>
            <span className={cls.gray_text}>Новый пароль</span>
            <input
              className={cls.input}
              autoFocus
              autoComplete="off"
              value={newPassword}
              onChange={(event) => setNewPassword(event.target.value)}
              placeholder="Введите новый пароль"
              type="password"
            />
          </div>
          <div className={cls.login}>
            <span className={cls.gray_text}>Подтвердите пароль</span>
            <input
              className={cls.input}
              autoComplete="off"
              value={confirmPassword}
              onChange={(event) => setConfirmPassword(event.target.value)}
              placeholder="Подтвердите новый пароль"
              type="password"
            />
          </div>
          {error && <p className={cls.error}>{error}</p>}
        </DialogContent>

        <div className={cls.btnContainer}>
          <Button type="primary" onClick={onPasswordChange}>
            Сменить
          </Button>
        </div>
      </Dialog>
    );
  if (stage === 2)
    return (
      <Dialog
        fullScreen={fullScreen}
        open={isSwowModal}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        classes={{ paper: cls.dialog_paper }}
        onKeyUp={onKeyUp}
      >
        <DialogTitle sx={{ color: "#3B7CBE" }}>
          Пароль успешно изменен
        </DialogTitle>

        <DialogContent>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: "28px",
            }}
          >
            <div
              style={{
                color: "#144579",
                backgroundColor: "#F2F6FB",
                borderRadius: "8px",
              }}
            >
              ******
            </div>
            <ShieldIcon />
          </div>
        </DialogContent>
        <div className={cls.btnContainer}>
          <button className={cls.button_bright} onClick={handleClose}>
            Закрыть
          </button>
        </div>
      </Dialog>
    );
}

export default ModalChangePassword;
